import StoreMix from '@lottery.admin.2.0/mixin/store.modul.js'
export default StoreMix